export const INTENT = {
  BUY: 'buy',
  LEASE: 'lease',
  SELL: 'sell',
};
export default INTENT;
